import { createContext } from "react";
import type { TransformDefinition } from "../../configTypes";

/** Provides transform dependency info to deeply-nested table row components
 * without threading props through intermediate form components. */
export interface TransformCrossRefContextValue {
  transforms: TransformDefinition[];
  connectorPrefix: string;
}

export const TransformCrossRefContext = createContext<TransformCrossRefContextValue | null>(null);
